export default function Noticias(){
    return <div>Noticias</div>;
}